import {arrayOf, bool, shape, string} from 'prop-types';
import {PropertySiteV1, Source} from '@sinclair-digital/stl-common/src/models/Property';
import {uniqBy, prop, append} from 'ramda';

interface SourceMap {
    [k: string]: boolean;
}

export interface Sources {
    includedSources: Source[];
    excludedSources: Source[];
}

export const sourceOptics = {
    name: 'name',
    locked: 'locked',
};

const sourceShape = {
    name: string,
    locked: bool,
};

export const defaultSource: Sources = {
    excludedSources: [],
    includedSources: [],
};

export const sourcesShape = {
    excludedSources: arrayOf(shape(sourceShape)),
    includedSources: arrayOf(shape(sourceShape)),
};

export const fromSourceMapToSources = (tagMap: SourceMap): Source[] =>
    Object.keys(tagMap).map(name => ({name, locked: tagMap[name]}));

export const parseSources = (property: PropertySiteV1): Sources => {
    const exSources: SourceMap = {};
    const incSources: SourceMap = {};

    const {includedSources, excludedSources, name, network, designatedMarketArea} = property;
    if (includedSources) {
        // lock the name and network source tags
        includedSources.forEach(source => {
            incSources[source.name] = source.locked;
        });
    }
    if (name) {
        incSources[name] = true;
    }
    incSources[network] = true;
    if (excludedSources) {
        excludedSources.forEach(source => {
            exSources[source.name] = source.locked;
        });
    }
    exSources[designatedMarketArea] = true;

    return {
        includedSources: fromSourceMapToSources(incSources),
        excludedSources: fromSourceMapToSources(exSources),
    };
};

export const serializeSources = ({includedSources, excludedSources}: Sources) => ({
    excludedSources,
    includedSources,
});

export const addSource = (name: string) => (sources: Source[]) => {
    const newSource: Source = {name, locked: false};
    return uniqBy(prop('name'), append(newSource, sources));
};

export type SourceGroup = 'includedSources' | 'excludedSources';
